"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Styling_1 = require("../../Styling");
exports.getClassNames = Utilities_1.memoizeFunction(function (styles, disabled, isChecked, isReversed, className) {
    return {
        root: Styling_1.mergeStyles('ms-Checkbox', isReversed && 'reversed', isChecked && 'is-checked', !disabled && 'is-enabled', disabled && 'is-disabled', className, styles.root, !disabled && [
            !isChecked && {
                selectors: {
                    ':hover .ms-Checkbox-checkbox': styles.checkboxHovered,
                    ':focus .ms-Checkbox-checkbox': styles.checkboxFocused
                }
            },
            isChecked && {
                selectors: {
                    ':hover .ms-Checkbox-checkbox': styles.checkboxCheckedHovered,
                    ':focus .ms-Checkbox-checkbox': styles.checkboxCheckedFocused
                }
            },
            {
                selectors: {
                    ':hover .ms-Checkbox-text': styles.textHovered,
                    ':focus .ms-Checkbox-text': styles.textFocused
                }
            }
        ]),
        label: Styling_1.mergeStyles('ms-Checkbox-label', styles.label, isReversed && styles.labelReversed, disabled && styles.labelDisabled),
        checkbox: Styling_1.mergeStyles('ms-Checkbox-checkbox', styles.checkbox, !disabled && isChecked && styles.checkboxChecked, disabled && !isChecked && styles.checkboxDisabled, disabled && isChecked && styles.checkboxCheckedDisabled),
        checkmark: Styling_1.mergeStyles(styles.checkmark, !disabled && isChecked && styles.checkmarkChecked, disabled && !isChecked && styles.checkmarkDisabled, disabled && isChecked && styles.checkmarkCheckedDisabled),
        text: Styling_1.mergeStyles('ms-Checkbox-text', styles.text, disabled && styles.textDisabled),
    };
});
//# sourceMappingURL=Checkbox.classNames.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Checkbox/Checkbox.classNames.js
// module id = 1487
// module chunks = 0